import { getMetadataConfig } from "src/metadata/actions";
import { MetadataFrontEndConfig } from "src/metadata/types";
import { reducerWithInitialState } from "typescript-fsa-reducers";

export interface MetadataState {
  frontEndConfig: MetadataFrontEndConfig | null;
}

export const initialState: MetadataState = {
  frontEndConfig: null
};

const metadataReducer = reducerWithInitialState<Readonly<MetadataState>>(
  initialState
).case(getMetadataConfig.async.done, (state, { result: frontEndConfig }) => ({
  frontEndConfig
}));

export default metadataReducer;



// WEBPACK FOOTER //
// ./src/metadata/reducer.ts